import wire from '../wire';
import { storage } from '../../auth/utils';

let module = wire(
  'home',
  '',
  ($rootScope, Account) => {
    'ngInject';

    // check for homepage version redirect to vue /home or /dashboard
    const homeKey = storage.get('new-home');
    const url = homeKey === '0' ? 'home' : 'broadcasts';

    // Function to handle redirection based on account data
    const redirectBasedOnAccount = (account) => {
      const isMixingStationOrigin = !!account.mixing_station_sign_up;
      const isRemoteMixOrigin = account.metadata && account.metadata.remote_mix_sign_up;
      const isRemoteMixOrMixStationOrigin = isMixingStationOrigin || isRemoteMixOrigin;
      if (isRemoteMixOrMixStationOrigin) {
        window.location.replace(`${window.VUE_DASHBOARD_ROOT}/mixing-station-web/redirect`);
      } else {
        // Redirect to Vue dashboard
        window.location.replace(`${window.VUE_DASHBOARD_ROOT}/${url}`);
      }
      return;
    };

    // Check if account info is already in $rootScope before making a fresh call
    if ($rootScope.account && $rootScope.account.metadata) {
      // Use the existing account info
      redirectBasedOnAccount($rootScope.account);
    } else {
      // If account info is not available, get it before redirecting
      // Getting it here ensures we have the account info before redirecting, hopefully avoiding any race conditions or reactivity issues
      Account.get((acc) => {
        redirectBasedOnAccount(acc);
      });
    }
  },
  'HomeController',
  '/'
);
export default module;



// WEBPACK FOOTER //
// ./app/pages/home/_index.js